import { render, staticRenderFns } from "./IframeDialog.vue?vue&type=template&id=4268fcc6&scoped=true"
import script from "./IframeDialog.vue?vue&type=script&lang=js"
export * from "./IframeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4268fcc6",
  null
  
)

export default component.exports